<template>
  <div class="Trafficlight-box">
    <div class="mode">mode: {{ modeMap[overwriteMode] }}</div>
    <div :class="tranfficLightData[0]?.main ? 'hasMain' : ''">
      <MainTrafficlightItem :remainingTimes="tranfficLightData[0]?.id" :totalTimes="tranfficLightData[0]?.totalTimes"
        :className="tranfficLightData[0]?.trafficLightClassName" :title="tranfficLightData[0]?.title"
        :main="tranfficLightData[0]?.main">
        <span class="more" @click="draggableConfig.isShow = !draggableConfig.isShow">
          {{ draggableConfig.isShow ? '收起' : '更多' }}
        </span>
      </MainTrafficlightItem>
    </div>
  </div>
  <g-drag-resize :config="draggableConfig">
    <template #default>
      <div class="overflow">
        <div class="close" @click="draggableConfig.isShow = false">
          <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2134" width="35"
            height="35">
            <path
              d="M563.8 512l262.5-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
              p-id="2135" fill="#ffffff"></path>
          </svg>
        </div>
        <div v-if="tranfficLightData.length" class="light">
          <traffic-light v-for="item in tranfficLightData" :key="item" :remainingTimes="item?.id"
            :totalTimes="item?.totalTimes" :className="item?.trafficLightClassName" :title="item?.title"
            :main="item?.main" />
        </div>
        <div v-else style="text-align: center; line-height: 60px; color: #fff">
          暂无数据
        </div>
      </div>
    </template>
  </g-drag-resize>
</template>

<script setup>
import { computed, watch, ref, provide, reactive } from 'vue';
import MainTrafficlightItem from './components/MainTrafficlightItem.vue';
import trafficLight from './components/TrafficlightItem.vue';
import GDragResize from '@/components/GDragResize/index.vue';
import { useFrameDataStore } from "@/store/frameDataStore";
let frameDataStore = useFrameDataStore();
provide('identity', 'identity');
const tranfficLightData = ref([]);
let overwriteMode = ref(0);
const modeMap = {
  0: '正常识别',
  1: '非红即走',
  2: '强行通过',
};

const draggableConfig = reactive({
  x: 0,
  y: 0,
  w: window.innerWidth - 500,
  h: 100,
  minH: 100,
  isShow: false,
  nameSpace: 'trafficLights',
  customClass: 'trafficLightPopover',
});

/**
  * 播放区间
*/
watch(() => frameDataStore.currentTimeInterval, (value) => {
  tranfficLightData.value = [];
})

let count = 0;
watch(() => frameDataStore.currentData, (e) => {
  if (e?.vehicleData?.trafficLightList.length) {
    count = 0;
    const arr = [];
    e.vehicleData.trafficLightList.forEach((item) => {
      if (!item.mainLight?.main) {
        arr.push(item);
      } else {
        arr.unshift(item);
      }
    });

    tranfficLightData.value = arr.map((item) => {
      let trafficLightClassName = '';
      let totalTimes = '';
      let title = '';
      let main = '';
      switch (item.light) {
        case 0:
          trafficLightClassName = 'unknown';
          break;
        case 1:
          trafficLightClassName = 'red';
          break;
        case 2:
          trafficLightClassName = 'green';
          break;
        case 3:
          trafficLightClassName = 'yellow';
          break;
        case 4:
          trafficLightClassName = '';
          break;
        default:
      }
      switch (item.multiFrameState) {
        case 0:
          title = 'TL_NONE';
          break;
        case 1:
          title = 'TL_FLASHING_GREEN';
          break;
        case 2:
          title = 'TL_FLASHING_RED';
          break;
        case 3:
          title = 'TL_FLASHING_YELLOW';
          break;
        case 4:
          title = 'TL_CONTINUE_UNKNOWN';
          break;
        case 5:
          title = 'TL_CONTINUE_BLACK';
          break;
        case 6:
          title = 'TL_CONTINUE_GREEN';
          break;
        case 7:
          title = 'TL_CONTINUE_RED';
          break;
        case 8:
          title = 'TL_CONTINUE_YELLOW';
          break;
        default:
      }
      switch (item?.mainLight?.source) {
        case 0:
          main = 'UNKNOWN';
          break;
        case 1:
          main = 'PLANNING_INTEREST';
          break;
        case 2:
          main = 'PERCEPTION';
          break;
        case 3:
          main = 'PERCEPTION_ALL_UNKNOWN';
          break;
        default:
      }
      if (item.duration) {
        totalTimes = Number(item.duration).toFixed(2);
      }

      return {
        ...item,
        trafficLightClassName,
        totalTimes,
        title,
        main,
      };
    });
  } else {
    count++;
    if (count === 10) {
      count = 0;
      tranfficLightData.value = [];
    }
  }

  if (typeof e?.vehicleData?.overwriteMode == 'number') {
    overwriteMode.value = e?.vehicleData?.overwriteMode;
  }
},
);
</script>
<style lang="less">
.Trafficlight-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:10px;
  font-size: 12px;
  color: #fff;
  margin-bottom: 10px;

  .mode {
    position: absolute;
    left: 92px;
    top: -22px;
    font-size: 14px;
  }

  .more {
    cursor: pointer;
    height: 20px;
    position: relative;
    padding-left: 13px;
    color: #3af6ff;

    &::after {
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 4px solid #3af6ff;
      border-right: 4px solid transparent;
      content: '';
      position: absolute;
      top: 50%;
      right: -12px;
      transform: translateY(-50%);
    }
  }
}

.moreTrafficLights {
  position: absolute;
  left: -110px;
  top: 36px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;

  &.active,
  &:hover {
    color: aqua;
  }
}

.trafficLightPopover {
  position: fixed;
  z-index: 3010 !important;
  background: url(@/assets/images/modal-bg.png) no-repeat;
  background-size: 100% 100%;
  padding: 15px 22px;
  box-shadow: 0 0 16px #ccc;

  .overflow {
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .light {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .Trafficlight {
    position: relative;
  }

  .Trafficlight::after {
    content: '';
    position: absolute;
    top: 8px;
    right: -3px;
    bottom: 0;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }
}

.close {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 22;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  svg {
    width: 20px;
  }
}

.hasMain .light-box::after {
  top: 25px !important;
}
</style>
